import { AUTH_ACTIONS, initialAuthState } from './auth.types';
/**
 *
 * @param {AuthSlice} state
 * @param {AuthReducerAction} action
 * @returns
 */
export function authReducer(state = initialAuthState, { type, payload }) {
    switch (type) {
        case AUTH_ACTIONS.SET_AUTH_STATUS:
            return { ...state, status: payload };
        case AUTH_ACTIONS.SET_AUTH_ERRORS:
            return { ...state, errors: [payload, ...state.errors] };
        case AUTH_ACTIONS.SET_AUTH_TASK:
            return { ...state, task: payload };
        case AUTH_ACTIONS.SET_AUTH_SESSION:
            return { ...state, session: payload };
        case AUTH_ACTIONS.SET_AUTH_AUTHENTICATED:
            return { ...state, isAuthenticated: payload };
        case AUTH_ACTIONS.SET_AUTH_INITIALIZED:
            return { ...state, isInitialized: payload };
        case AUTH_ACTIONS.SET_AUTH_LOGIN_METHOD:
            return { ...state, loginMethod: payload };
        case AUTH_ACTIONS.SET_AUTH_LAST_ACTIVITY:
            return { ...state, lastActivity: payload };
        case AUTH_ACTIONS.SET_AUTH_SESSION_TIMEOUT:
            return { ...state, sessionTimeout: payload };
        case AUTH_ACTIONS.INCREMENT_AUTH_LOGIN_ATTEMPTS:
            return { ...state, loginAttempts: state.loginAttempts + 1 };
        case AUTH_ACTIONS.CLEAR_AUTH_LOGIN_ATTEMPTS:
            return { ...state, loginAttempts: 0 };
        case AUTH_ACTIONS.SET_AUTH_LOCKOUT_UNTIL:
            return { ...state, lockoutUntil: payload };
        case AUTH_ACTIONS.SET_AUTH_REDIRECT_URL:
            return { ...state, redirectUrl: payload };
        case AUTH_ACTIONS.SET_AUTH_TWO_FACTOR_REQUIRED:
            return { ...state, twoFactorRequired: payload };
        case AUTH_ACTIONS.SET_AUTH_TWO_FACTOR_TOKEN:
            return { ...state, twoFactorToken: payload };
        case AUTH_ACTIONS.SET_AUTH_PERMISSIONS:
            return { ...state, permissions: payload };
        case AUTH_ACTIONS.SET_AUTH_DEV_TOKEN:
            return { ...state, devToken: payload };
        case AUTH_ACTIONS.LOGOUT:
            return { ...initialAuthState, status: 'succeeded', isInitialized: true };
        default:
            return state;
    }
}
